/**
 * ApiIntegrationType
 *
 * @hidden
 * Should match server enum found at \SWSSystem\SuccessWebsiteAPI\Integrations\Integrations.cs
 *
 *
 */
export enum ApiIntegrationType {
    AMSKey = 100,
    ZillowKey = 101,
    ZapierKey = 102,
}
